export enum CadacExpertType {
	None = 0,
	Internal = 229380000, // 0x0DAC0FA0
	External = 229380001, // 0x0DAC0FA1
}
